{
  "zh-TW": {
    "dressingRoom": {
      "lead": "把護甲和內襯服搭配在一起，以 3D 檢視裝扮。透過連結分享，或登入後儲存。",
      "slots": {
        "helmet": "頭盔",
        "torso": "軀幹",
        "arms": "手臂",
        "legs": "腿部",
        "backpack": "背包",
        "undersuit": "內襯服",
        "primary": "主武器",
        "secondary": "副武器",
        "sidearm": "手槍"
      },
      "size": "S%{size}",
      "choose": "選擇…",
      "remove": "移除",
      "openItem": "開啟物品頁面",
      "notFound": "找不到物品",
      "noHolo": "尚無 3D 模型",
      "empty": "為任一欄位選擇一件裝備即可檢視裝扮。",
      "pose": "姿勢",
      "copyLink": "複製連結",
      "savedOutfits": "已儲存的裝扮",
      "signInToSave": "登入後即可儲存裝扮。",
      "outfitName": "裝扮名稱",
      "nameTaken": "你已經有一套同名的裝扮。",
      "saveNew": "另存為新裝扮",
      "saveChanges": "儲存變更",
      "noOutfits": "還沒有儲存的裝扮。",
      "pieces": {
        "one": "%{count} 件",
        "other": "%{count} 件"
      },
      "confirmDelete": "刪除裝扮 %{name}？",
      "messages": {
        "saved": "裝扮已儲存。",
        "saveFailed": "無法儲存裝扮。",
        "deleteFailed": "無法刪除裝扮。",
        "linkCopied": "連結已複製。",
        "copyFailed": "無法複製連結。"
      },
      "groups": {
        "armour": "護甲",
        "weapons": "武器",
        "gear": "裝備"
      },
      "hold": "手持",
      "bodies": {
        "male": "男性",
        "female": "女性"
      },
      "positionPending": "位置尚未匯出",
      "fit": {
        "noPort": "%{item} 沒有此欄位",
        "doesNotFit": "與 %{item} 不相容",
        "noWornPiece": "所穿部件沒有可放置此物的位置"
      },
      "armorSets": {
        "open": "護甲套裝",
        "count": {
          "one": "%{count} 套",
          "other": "%{count} 套"
        }
      },
      "gearHint": "穿上軀幹、腿甲或內襯服，即可攜帶手榴彈、彈匣、針劑和工具。",
      "gear": {
        "grenade": "手榴彈 %{number}",
        "magazine": "彈匣 %{number}",
        "gadget": "小工具",
        "medpen": "醫療筆 %{number}",
        "oxypen": "氧氣筆 %{number}",
        "utility": "工具 %{number}"
      },
      "saveBlocked": "請先修正上方標記的問題，再儲存此裝扮。",
      "storage": {
        "title": "儲物",
        "space": "%{used} / %{capacity}",
        "add": "新增物品",
        "fewer": "減少一個",
        "more": "增加一個",
        "pickerTitle": "新增到%{piece}",
        "problems": {
          "noStorage": "此處沒有穿戴可容納這些物品的部件。",
          "overCapacity": "所存物品超出此部件的容量。",
          "tooLarge": "存有對此部件來說過大的物品。",
          "unmeasured": "存有沒有測量尺寸的物品。"
        },
        "misfit": {
          "unmeasured": "沒有測量尺寸",
          "tooLarge": "對此部件來說過大",
          "noRoom": "剩餘空間不足"
        }
      },
      "gearNone": "你所穿的部件沒有裝備欄位。",
      "gearColumns": {
        "magazine": "彈藥",
        "grenade": "手榴彈",
        "medpen": "醫療筆",
        "oxypen": "氧氣筆"
      }
    }
  }
}
